import FacebookLogin from "@greatsumini/react-facebook-login";

const FaceBookLoginButton = ({
  setAccessToken,
  setFBUserID,
  autoLoad = false,
  isConsentChecked = false,
}: any) => {
  return (
    <FacebookLogin
      className={`facebook-button ${isConsentChecked ? "active" : "disabled"}`}
      // appId="368961369584355"  //ASEUM INFOTECH
      // appId="1312314427085095" // AICRM LEADS
      appId="758851883765119" // AICRM
      scope="email,public_profile,leads_retrieval,pages_show_list,pages_manage_metadata,pages_read_engagement"
      autoLoad={autoLoad && isConsentChecked}
      onSuccess={(response) => {
        if (isConsentChecked) {
          console.log("Login Success!", response);
          setAccessToken(response?.accessToken);
          setFBUserID(response?.userID);
          localStorage.setItem("FBUserID", response?.userID);
        }
      }}
      onFail={(error) => {
        console.log("Login Failed!", error);
      }}
      onProfileSuccess={(response) => {
        console.log("Profile Data:", response);
      }}
      render={({ onClick }) => (
        <button
          className={`facebook-button ${
            isConsentChecked ? "active" : "disabled"
          }`}
          onClick={isConsentChecked ? onClick : undefined}
          disabled={!isConsentChecked}
        >
          Login with Facebook
        </button>
      )}
    />
  );
};

export default FaceBookLoginButton;
